import SmartImportPicker from '../../components/SmartImportPicker/SmartImportPicker';

export default function ImportsLandingPage() {
  return <SmartImportPicker />;
}
